import type { MediaKind, Model } from './contracts';

export function modelProvider(model?: Model): string {
  const label = model?.provider?.trim() || 'Other';
  if (/^(flux|bfl|black forest labs)$/i.test(label)) return 'Black Forest Labs';
  if (/^(qwen|alibaba)$/i.test(label)) return 'Alibaba';
  if (/^bytedance$/i.test(label)) return 'ByteDance';
  return label;
}

// Local editorial picks fill Featured until the catalogue supplies its own picks.
// Resolve against the already filtered catalogue so unavailable models never appear.
const picks: Record<MediaKind, readonly (readonly RegExp[])[]> = {
  image: [
    [/^GPT Image 2\.5 Sunburst$/i, /^GPT Image 2$/i, /^GPT Image/i],
    [/^Nano Banana 2\.1$/i, /^Nano Banana Pro$/i, /^Nano Banana/i],
    [/^FLUX\.2 Pro$/i, /^FLUX\.2 Flex$/i, /^FLUX/i],
    [/^Ideogram 4\.5$/i, /^Ideogram/i],
  ],
  video: [
    [/^Veo 3\.1/i, /^Veo/i], [/^Kling 3/i, /^Kling/i],
    [/^Seedance 2/i, /^Seedance/i], [/^Sora 2/i, /^Sora/i],
  ],
};

export function featuredModels(models: readonly Model[], kind: MediaKind): Model[] {
  const featured = models.filter(model => model.featured);
  if (featured.length) return featured;
  return picks[kind].flatMap(family => {
    for (const name of family) {
      const match = models.find(model => name.test(model.name));
      if (match) return [match];
    }
    return [];
  });
}
